"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (ohlc1, ohlc2) {
    var o1Len = ohlc1.length;
    var o2Len = ohlc2.length;

    if (o1Len !== o2Len) {
        return false;
    }

    if (o1Len === 0) {
        return true;
    }

    var o1Last = ohlc1[o1Len - 1];
    var o2Last = ohlc2[o2Len - 1];

    return o1Last.epoch === o2Last.epoch && o1Last.close === o2Last.close;
};